import { useEffect} from "react";
import { GovType, MapType, SelectedLayersType } from "../../../types/dataTypes";
import ViewLayerGroup from "../../Layers/ViewLayerGroup";
import { TEXT_INTRO, TEXT_OVERVIEW } from "../../../utils/text";
import { LAYER_IDS } from "../../../utils/mapConsts";
import styled from '@emotion/styled';
import { faDownload, faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";
import Container from "../../Shared/Container";
import LinkButton from "../../Shared/LinkButton";
import { BREAKPOINTS, COLORS_BASE, STYLES } from "../../../utils/consts";
import GovDropdown from "./GovDropDown";
import Button from "../../Shared/Button";
import { useNavigate } from "react-router-dom";
import FilterSection from "./FilterSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

type SidebarProps = {
  map: MapType
  selectedLayers: SelectedLayersType[];
  setSelectedLayers: Function;
  gov_adm1: GovType;
  numberSelectedSettlements: number;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
};

function Sidebar({map, selectedLayers, setSelectedLayers, gov_adm1, numberSelectedSettlements, isMobileOpen = false, onCloseMobile}: SidebarProps) {  
    const navigate = useNavigate();

    const handleDownloadClick = () => {
      navigate('/', { state: { scrollToDownloadTable: true } });
    };
  
  
  return (    
     <SidebarStyle isMobileOpen={isMobileOpen}>
        <MobileSidebarHeader>
          <span>Map tools</span>
          <MobileCloseButton type="button" onClick={onCloseMobile} aria-label="Close map tools">
            <FontAwesomeIcon icon={faClose} />
          </MobileCloseButton>
        </MobileSidebarHeader>
        <SidebarContentStyle>            
          <GovDropdown map={map} gov_adm1={gov_adm1}/> 
        </SidebarContentStyle>
        <SidebarContentStyle>
          <FilterSection map={map} numberSelectedSettlements= {numberSelectedSettlements}/> 
        </SidebarContentStyle>
        <SidebarContentStyle>
          <ViewLayerGroup map={map} selectedLayers = {selectedLayers} setSelectedLayers={setSelectedLayers}/>
        </SidebarContentStyle>
        <SidebarContentStyle style={{display: 'flex', justifyContent: 'center'}}>
          <LinkButton to={'/#datadownload'} text={'Download map data'} icon={faDownload}/>
          {/* <Button icon={faDownload} filledStyle={true} onClick={() => window.open("download", '_blank')}>
            Download map datareac
          </Button> */}
        </SidebarContentStyle>
      </SidebarStyle>
  );
}

export default Sidebar;

const SidebarStyle = styled.div<{ isMobileOpen: boolean }>(
  ({ isMobileOpen }) => `
    margin-top: 80px;
    position: relative;
    display: flex;
    flex-direction: column;
    width: ${STYLES.SIDEBAR_WIDTH}px;
    height: calc(100vh - 80px);
    background-color: ${COLORS_BASE.GREYS.MAIN};
    overflow: auto;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      position: absolute;
      top: 0;
      left: 0;
      margin-top: 0;
      width: min(86vw, 360px);
      max-width: calc(100vw - 32px);
      height: 100%;
      z-index: 1001;
      box-shadow: 0 18px 40px rgba(0, 0, 0, 0.22);
      transform: translateX(${isMobileOpen ? '0' : '-105%'});
      transition: transform 0.25s ease;
    }
`
);

const SidebarContentStyle = styled.div<{}>(() => `
    padding: 20px;
    max-width: ${STYLES.SIDEBAR_WIDTH}px;

    @media (max-width: ${BREAKPOINTS.MOBILE}) {
      max-width: 100%;
      padding: 16px;
    }
  `
);

const MobileSidebarHeader = styled.div`
  display: none;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: white;
    border-bottom: 1px solid ${COLORS_BASE.GREYS.HIGHLIGHT};
    font-weight: 700;
    color: ${COLORS_BASE.BRAND.DARKER};
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

const MobileCloseButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: ${COLORS_BASE.BRAND.MAIN};
  color: white;
`;